export enum USER_ROLES_RAW_DATA {
  User = "User",
  Administrator = "Administrator",
  TeltonikaSupport = "TeltonikaSupport",
  // remove Support from the list when TeltonikaSupport is fixed everywhere in BE
  Support = "Teltonika Support"
}

//All possible permissions list from GET Users/Me "permissions" object
export enum USER_PERMISSIONS {
  DeleteUsers = "CanDeleteUsers",
  DisableVehicles = "CanDisableVehicles",
  DownloadFiles = "CanDownloadFiles",
  EditCompanies = "CanEditCompanies",
  EnableSampleCredits = "CanEnableSampleCredits",
  ManageAllUsers = "CanManageAllUsers",
  ManageSchedules = "CanManageSchedules",
  ManageQuickSchedules = "CanManageQuickSchedules",
  ManageVehicles = "CanManageVehicles",
  ManageDrivers = "CanManageDrivers",
  ManageCompanies = "CanManageCompanies",
  ManageUsers = "CanManageUsers",
  ManageCompanyCards = "CanManageCompanyCards",
  ManageNews = "CanManageNews",
  ManageApiCredentials = "CanManageApiCredentials",
  ManageIntegrations = "CanManageIntegrations",
  PublishNews = "CanPublishNews",
  SeeCompanyHierarchy = "CanSeeCompanyHierarchy",
  SeeCreditsDashboard = "CanSeeCreditsDashboard",
  ManageCreditReport = "CanManageCreditReport",
  ManageEmailNotifications = "CanManageEmailNotifications",
  SeeAnalysisProviders = "CanSeeAnalysisProviders"
}
